// Generated by purs version 0.11.7
"use strict";
var Data_Lens_Lens_Tuple = require("../Data.Lens.Lens.Tuple");
var Data_Lens_Lens_Unit = require("../Data.Lens.Lens.Unit");
var Data_Lens_Prism_Either = require("../Data.Lens.Prism.Either");
var Data_Lens_Prism_Maybe = require("../Data.Lens.Prism.Maybe");
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Lens.Common/index.js
// module id = 548
// module chunks = 0